import { render, staticRenderFns } from "./ChatPanel.vue?vue&type=template&id=bfbd2244&scoped=true"
import script from "./ChatPanel.vue?vue&type=script&lang=js"
export * from "./ChatPanel.vue?vue&type=script&lang=js"
import style0 from "./ChatPanel.vue?vue&type=style&index=0&id=bfbd2244&prod&scoped=true&lang=css"
import style1 from "./ChatPanel.vue?vue&type=style&index=1&id=bfbd2244&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbd2244",
  null
  
)

export default component.exports